<template lang="pug">
.home
  .home__copy
    p From the OGs to the latest generation of Falcons fans, we’re all Dirty Birds! Rise Up and create your custom Dirty Birds profile picture by clicking the button below.
    router-link.btn(id="getStartedBtn" :to="{ name: 'Generator' }") Get Started
  gallery.home__gallery
</template>

<script>
// import debug from 'debug'

import Gallery from '../components/Gallery'

// const log = debug('view:Home')

export default {
  name: 'Home',
  components: { Gallery },
}
</script>

<style lang="scss" scoped>
.home {
  &__copy {
    text-align: center;
    max-width: 37.5rem;
    margin: 0 auto;
    padding: 30px;

    p {
      font-size: 1.25rem;
      margin-bottom: 1.875rem;
    }
  }
}
</style>
